import { Button, makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorIcon from '../../../../components/svgIcons/ErrorIcon'

const ErrorContent = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      <div className={classes.errorHeading}>
        <ErrorIcon />
        <div className={classes.errorHeadingLabel}>{t('compensation_popup_error_heading')}</div>
      </div>
      <div className={classes.text}>{t('compensation_popup_error_message')}</div>
      <div>
        <form action="mailto: gsd@dental21.de">
          <Button color="primary" variant="contained" type="submit" fullWidth>
            {t('action.send_email')}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default ErrorContent

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  errorHeading: {
    fontWeight: 700,
    fontSize: 17,
    lineHeight: '28px',
    textAlign: 'center',
    letterSpacing: '0.5px',
    color: '#A91B34',
    marginBottom: 24,
    display: 'flex',
    alignItems: 'center',
  },
  errorHeadingLabel: {
    marginLeft: 16,
  },
  text: {
    fontWeight: 700,
    fontSize: 15,
    lineHeight: '24px',
    textAlign: 'center',
    letterSpacing: '0.25px',
    color: '#212121',
    marginBottom: 16,
  },
})
